export default "__VITE_ASSET__B6Xkvo07__"